import { EmptyState, SearchIcon } from "@pharaday/lighthouse";

export interface ErrorNavigationProps {
  statusCode?: number | null;
  error?: Error;
  message?: string;
  errorId?: string;
  children?: never;
}

const ErrorNavigation = ({ message }: ErrorNavigationProps) => {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center">
      <EmptyState.Root size="lg">
        <EmptyState.IllustrationBox.Gray />
        <EmptyState.IllustrationIcon color="gray">
          <SearchIcon />
        </EmptyState.IllustrationIcon>
      </EmptyState.Root>
      <h2 className="mt-6 text-xl font-semibold text-neutral-10">Whoops!</h2>
      <p className="mt-2 text-base font-semibold text-neutral-30">
        {message ?? "Something went wrong. Please try again later."}
      </p>
    </div>
  );
};

export default ErrorNavigation;
